import { useToast } from "@chakra-ui/react";
import { useState } from "react";
import { post } from "../config/axiosConfig.ts";

export const useForgotPass = (calback: (x: { login: string }) => void) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [forgot, setForgot] = useState(null);
  const toast = useToast();

  const submit = async (data) => {
    setLoading(true); // Set loading state
    try {
      const res = await post(`user/login/forget-password?mail=${data}`, {});
      setForgot(res);
      calback({ login: "" });
      toast({
        position: "top",
        title: "Successfully logged in",
        status: "success",
        isClosable: true,
      });
    } catch (error) {
      toast({
        position: "top",
        title: "Incorrect username or password",
        status: "error",
        isClosable: true,
      });
      console.log(error);
    } finally {
      setLoading(false); // Stop loading state
    }
  };

  return { submit, loading, forgot };
};
